<template lang="html">
    <div class="app" v-if="category">

        <Header></Header>
        <TypesMenu></TypesMenu>

        <div class="section section-grey py-5">
            <div class="container">
                <h1 class="text-center mb-4">{{category.name}}</h1>
                <p class="text-center mb-2"><b>{{category.count_subscribed}}</b> materiale inscrise, <b>{{category.count_nominations}}</b> materiale nominalizate.</p>
                <p class="text-center mb-5">
                    <b>Primele 5 locuri</b> sunt premiate si puncteaza in clasamentul general care va desemna
                    <b>
                        <template v-if="this.$route.params.type == 'fotografie'">Fotograful Anului</template>
                        <template v-if="this.$route.params.type == 'videografie'">Videograful Anului</template>
                    </b>
                </p>
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <router-link :to="{name: 'index', params: {type: this.$route.params.type}}" class="btn btn-light btn-lg w-100 mb-4"><i class="fas fa-chevron-left"></i> Inapoi la categorii</router-link>
                    </div>
                    <div class="col-12 col-sm-6">
                        <router-link :to="{name: 'rank', params: {type: this.$route.params.type}}" class="btn btn-primary btn-lg w-100"><i class="fas fa-trophy"></i>  {{rankButtonText}}</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="" v-for="(material, index) in category.materials">
            <div class="section section-white py-5">
                <div class="container">
                    <div class="card text-center mb-4" v-bind:id="'mat' + material.id">
                        <div class="card-header" v-bind:class="{'': material.points}">
                            <div class="row align-items-center">
                                <div class="col-12 col-sm-6 text-center text-sm-left mb-2 mb-sm-0 align-items-center">
                                    <a :href="'https://www.fotografi-cameramani.ro' + material.user_url" target="_blank" class="member-link">

                                        <PlaceBadge class="mr-2" :place="material.loc" :primary="material.points"></PlaceBadge>

                                        <MemberPhoto :photo="material.fotografie" class="photo-small mr-2"></MemberPhoto>
                                        <div class="name">
                                            <b>{{material.nume}}</b>
                                        </div>
                                    </a>
                                </div>
                                <div class="col-12 col-sm-6 text-center text-sm-right">
                                    <div v-if="material.points">
                                        Nota juriu <b>{{material.jury_avg_grade}}</b> x {{material.points}} pct = <b class="text-success">{{material.points_total}} pct</b>
                                    </div>
                                    <div v-else>
                                        Nota juriu <b>{{material.jury_avg_grade}}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="" v-if="$route.params.type == 'fotografie'">
                                <img :src="thumbUrl(material.imagine)" class="img-thumbnail">
                            </div>
                            <div class="embed-responsive embed-responsive-16by9" v-if="$route.params.type == 'videografie'">
                                <div v-html="material.cod"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PromoRandom v-if="index%2 == 0" :msg="getRandomPromo()"></PromoRandom>
        </div>
        <div class="section-grey py-5 text-center">
            <div class="container">
                <h3 class="text-center mb-4">Clasament <b>{{category.name}}</b></h3>
                <div class="row text-center justify-content-center">
                    <div class="col-sm col-5" v-for="(cat, k) in reversedMaterials">
                        <div class="place mb-3 d-flex align-items-center justify-content-center">
                            <div class="">

                                <a :href="'https://www.fotografi-cameramani.ro' + cat.user_url" target="_blank" class="member-link">
                                    <MemberPhoto :photo="cat.fotografie" class="photo mb-2"></MemberPhoto>
                                    <PlaceBadge :place="cat.loc" :primary="false" :size="'small'"></PlaceBadge>
                                    <div class="author">
                                        {{cat.nume}}
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center mb-4">
                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <router-link :to="{name: 'index', params: {type: this.$route.params.type}}" class="btn btn-light btn-lg w-100 mb-4"><i class="fas fa-chevron-left"></i> Inapoi la categorii</router-link>
                        </div>
                        <div class="col-12 col-sm-6">
                            <router-link :to="{name: 'rank', params: {type: this.$route.params.type}}" class="btn btn-primary btn-lg w-100"><i class="fas fa-trophy"></i> Clasament intermediar</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <Material v-if="openedMaterial" :url="thumbUrl(openedMaterial.imagine)" v-on:closeMaterial="closeMaterial()"></Material> -->

        <PromoMembers></PromoMembers>

        <Sponsors></Sponsors>

        <PromoClients></PromoClients>

        <Stt></Stt>
    </div>
</template>

<script>

import Header from '../components/snippets/Header.vue'
import Stt from '../components/snippets/Stt.vue'
import TypesMenu from '../components/snippets/TypesMenu.vue'
import Sponsors from '../components/snippets/Sponsors.vue'
import PromoMembers from '../components/snippets/PromoMembers.vue'
import PromoClients from '../components/snippets/PromoClients.vue'
import PromoRandom from '../components/snippets/PromoRandom.vue'
import MemberPhoto from '../components/snippets/MemberPhoto.vue'
import PlaceBadge from '../components/snippets/PlaceBadge.vue'

// import Material from '../components/snippets/Material.vue'

import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'Category',
    components: {
        Header,
        TypesMenu,
        Sponsors,
        PromoMembers,
        PromoClients,
        PromoRandom,
        MemberPhoto,
        PlaceBadge,
        Stt
        // Material
    },
    metaInfo() {

        if(!this.category) return false;

        return {
            title: this.category.name + " - Concursul anual 2020 - Fotografi-Cameramani.ro",
            meta: [
                {name: 'description', content: this.category.name +  'Concursul anual 2020 - Fotografi-Cameramani.ro'},
                {property: 'og:title', content: this.category.name + "Concursul anual 2020 - Fotografi-Cameramani.ro"},
                {property: 'og:site_name', content: 'Fotografi-Cameramani.ro'},
                {property: 'og:type', content: 'website'},
            ]
        }
    },
    props: {
    },
    computed: {
        reversedMaterials: function () {

            if(!this.category.materials) return [];

            let materials = this.category.materials.map((x) => x);
            materials = materials.reverse();

            let tmp = [];
            for(let k in materials) {
                if(materials[k].loc <= 5) {
                    tmp.push(materials[k]);
                }
            }

            return tmp;
        },

        ...mapGetters('general', {
            categories: 'categories',
            rankButtonText: 'rankButtonText'
        }),

        category: function() {

            if(this.categories) {

                return this.categories[this.$route.params.id];
            }
        },
    },
    data: function() {
        return {
            promos: [
                {msg: '<a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani.ro</a> este <b>cel mai mare catalog al fotografilor și videografilor de nuntă din România</b>. Peste 1900 de fotografi și peste 800 de videografi din toată țara și-au completat profilele pe site. '},
                {msg: 'Pe <a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani.ro</a> găsești peste <b>2700 de fotografi și videografi</b> pe care-i poți contacta pentru evenimentul tău. Este cel ai simplu mod de a căuta un fotograf/videograf.'},
                {msg: 'Catalogul <a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani</a> este cel mai mare catalog foto-video din România, cu <b>informații actualizate zilnic</b>. Aici poți găsi cu ușurință fotografi și videografi <b>verificați</b>, cu <b>testimoniale reale</b> și <b>prețuri la vedere</b>. Poți vedea care sunt <b>evenimentele la care au fotografiat/filmat</b> până acum, precum și <b>portofolii complete</b>.'},
                {msg: 'Căutarea în catalog se face simplu. Nu ai nevoie să-ți faci cont pentru a folosi acest serviciu. <b>Alege județul sau orașul</b> în care se desfășoară nunta. <b>Bifează data nunții</b>. <b>Evaluează bugetul</b> și grupează sau nu fotografii/videografii <b>după preț</b>. Gândește-te dacă vrei să alegi un fotograf/videograf cu <b>portofoliu premiat</b>, <b>apreciat de clienți</b> sau cu <b>experiență</b>. Ți se vor afișa fotografii și videografii <b>disponibili</b>.'},
                {msg: 'Peste <b>70.000 de utilizatori</b> au vizitat catalogul <a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani</a> în 2020 și au "răsfoit" profilele fotografilor și videografilor înscriși.'},
                {msg: 'Pe <a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani.ro</a> găsești peste <b>2700 de fotografi și videografi</b>. Studiază cu atenție <b>portofoliile lor</b>, apoi <b>contactează-i</b>. Poți vedea numărul lor de <b>telefon</b>, le poți scrie pe <b>mail</b>, pe <b>WhatsApp</b> sau pe <b>Facebook Messenger</b>.'},
                {msg: '<b>Experiența</b> fotografului și videografului reprezintă un plus uriaș atunci când viitorii miri își aleg serviciile foto-video pentru nuntă. De aceea, pe <a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani.ro</a> <b>clienții pot sorta</b> fotografii și cameramanii în funcție de <b>experiența verificată</b>.'},
                {msg: '<b>Recomandările clienților</b> afișate pe profilul fotografilor și videografilor de pe <a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani</a> sunt cel mai bun indicator al muncii și, probabil, elementul cel mai important de care un client ține cont atunci când face o alegere. Fotografii și videografii din catalog primesc <b>testimoniale de la clienți verificați</b>.'},
                {msg: 'În catalogul <a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani.ro</a> poți sorta fotografii și videografii cu <b>portofoliu premiat</b>. Acest criteriu afișează doar fotografii și videografii ce au premii obținute la concursurile de fotografie și videografie desfășurate în catalog și la cele partenere. Premiile sunt o dovadă a aplicării unei <b>tehnici corecte</b>, cât și a <b>originalității materialelor</b>.'},
                {msg: 'În catalogul <a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani.ro</a> poți sorta fotografii și videografii dupa criteriul <b>Apreciere clienți</b>. Adunăm laolaltă <b>testimonialele</b> primite în catalog, <b>Facebook (reviews, like-uri)</b>, <b>Google Maps (reviews)</b>. Fotografi-Cameramani este singurul loc în care poți vedea toate aceste informații în același timp.'},
                {msg: 'În catalogul <a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani.ro</a> poți sorta fotografii și videografii dupa criteriul <b>Evenimente verificate</b>. Fotografii și videografii pot adăuga <b>evenimentele pe care le-au avut în trecut</b> și oferi <b>recenzii locațiilor</b>.'},
                {msg: 'Înscrierea în catalog nu îi costă nimic pe fotografi și videografi. De asemenea, nici miresele nu trebuie să plătească nimic dacă își aleg serviciile foto-video din catalog. '},
                {msg: '<a href="https://www.facebook.com/FotografiCameramani.ro" target="_blank">Comunitatea Fotografi-Cameramani</a> numără peste <b>20.000 de followers pe Facebook</b> și peste <b>2900 de followers pe Instagram</a>. În plus, <a href="https://www.facebook.com/groups/2169353246647564" target="_blank">grupul de Facebook dedicat membrilor</a> a trecut de 1000 de persoane.'},
                {msg: '<b>Miresele</b> găsesc cele mai bune <b>sfaturi pentru nunțile lor</b> de vis în revista <a href="https://www/wedme.ro" target="_blank">WedMe</a>: de la pregătiri, până la nuntă și luna de miere. <b>Peste 5000 de mirese</b> află în fiecare zi noutățile. '},
                {msg: '<a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani.ro</a> organizează <b>Concursul Anual de Fotografie și Videografie de nuntă</b> încă din 2013, având <b>jurați internaționali</b> de renume care aleg cele mai bune fotografii și clipuri de nuntă ale anului.'},
                {msg: 'Peste <b>10.000 de fotografi și mirese</b> s-au abonat la <b>Newsletterul</b> <a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani</a> și primesc noutăți din partea echipei. '},
                {msg: 'Peste <b>60.000 de fotografi și videografi au fost contactați de mirese</b> prin intermediul catalogului de la începutul său.'},
                {msg: 'Un <b>portofoliu bogat</b> îi propulsează automat pe fotografii și videografii din catalog în <b>topul preferințelor clienților</b> care sunt în căutarea serviciilor foto-video pentru ziua cea mare. Pe <a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani.ro</a>, toți fotografii și videografii și-au completat profilele, astfel încât viitorii miri pot face cea mai bună alegere. '},
                {msg: 'Pe <a href="https://www.fotografi-cameramani.ro" target="_blank">Fotografi-Cameramani.ro</a> poți selecta fotograful și videograful nunții tale în funcție de <b>bugetul de care dispui</b>. Am împărțit fotografii și videografii din catalog în trei categorii de preț: <b>sub 700 de euro</b>, <b>între 700 și 1000 de euro</b> și <b>peste 1000 de euro</b>. '},
                {msg: 'Pe Fotografi-Cameramani.ro găsești un <a href="https://www.fotografi-cameramani.ro/ghid-alegerea-fotografului-si-cameramanului-de-nunta" target="_blank">ghid complet pentru alegerea fotografului și videografului de nuntă</a>. Totul într-o singură pagină, cu informații complete.  '},
            ],

            usedPromos: [],

            openedMaterial: false
        }
    },
    mounted() {
        this.init();

        if(this.$route.hash) {

            let materialId = this.$route.hash.substring(1);
            let hash = this.$route.hash;
        }
    },
    methods: {

        init() {
            this.getBatch(this.$route.params.type);
        },

        // openMaterial(material) {
        //     this.openedMaterial = material;
        // },
        //
        // closeMaterial(material) {
        //     this.openedMaterial = false;
        // },

        ...mapActions('general', {
            getBatch: 'getBatch'
        }),

        getRandomPromo() {

            let randomIndex = Math.floor(Math.random() * this.promos.length);

            return this.promos[randomIndex].msg;

            this.promos.splice(randomIndex, 1);
        },

        thumbUrl(imagine) {

            if(this.$route.params.type == 'fotografie') {
                return 'https://www.fotografi-cameramani.ro/upload/imagini/imagine/slide/' + imagine;
            }

            if(this.$route.params.type == 'videografie') {
                return 'https://www.fotografi-cameramani.ro/upload/filme/imagine/slide/' + imagine;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.photo {
    width: 90px;

    @media (max-width: 768px) {
        width: 70px;
    }
}

.photo-small {
    max-width: 50px;
}

.embed-responsive {
    background: black;
}

.name {
    display: inline;

    @media (max-width: 768px) {

        display: block;
        margin-top: 10px;
    }
}

.place {
    // background: rgba(255,255,255,0.4);
    padding: 5px;
    // border-radius: 5px;
    max-width: 150px;
    height: 200px;
    // border: solid 1px #dddddd;

    @media (max-width: 768px) {
        height: 145px;
    }

    .author {
        line-height: 19px;
        font-size: 90%;
    }

    .placebadge {
        margin-top: -25px !important;
        z-index: 1000;
        position: relative;
        display: block;
        margin: 0 auto;
        opacity: 0.9;
    }
}

.img-thumbnail {

    @media (max-width: 768px) {

        padding: 0px;
        border: none;
    }
}

</style>
